import React from 'react';
import ReactDOM from "react-dom";
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router';
import configureStore from './utils/configureStore';

// Vendors
// ==========================================
// Vendors: Stylesheets
import './assets/vendors/normalize.scss';
import './assets/vendors/datepicker.scss';
import './assets/vendors/eva-icons.scss';
import './assets/vendors/circularProgressBar.scss';
import './assets/vendors/bootstrap.scss';
import "./assets/vendors/react-toastify.scss";

// Vendors: Scripts
// import './assets/vendors/init.js';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';


// Global
// ==========================================
// Global: Common
import './assets/stylesheets/agesma.scss';
import history from './utils/history';
import * as serviceWorker from './serviceWorker';

// Global: Views
import { Landing } from './landing';
import { Legal } from './legal';
import { Faqs } from "./faqs";
import Auth from './auth';
import { App } from './app';
import { Partner } from './partner';
import { Backoffice } from './backoffice';
import { Placeholder } from './auth/placeholder';

const store = configureStore({}, history);



ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route path="/index" component={Landing} />
                <Route path="/legal" component={Legal} />
                <Route path="/faqs" component={Faqs} />
                <Route path="/placeholder" component={Placeholder} />
                <Route path="/auth" component={Auth} />
                <Route path="/(anticipa|facilita)" component={App} />
                <Route path="/partner" component={Partner} />
                <Route path="/backoffice" component={Backoffice} />

                <Route render={() => {
                    return <Redirect exact to="/index" />;
                }} />
            </Switch>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
